import { jsx as o } from "react/jsx-runtime";
import { c as r } from "./clsx.OuTLNxxd.js";
import { u as d } from "./use-is-experience-editor.DQiAVZeB.js";
import { i as f, M as c } from "./module-link.BIP-6VCP.js";
import { NeuButton as k } from "@hcahealthcaredpx/neutron-react";
const N = (i) => {
  const a = d(), { href: u, field: t, children: l, as: L, ...e } = i, n = t && "value" in t ? t.value : t, m = n == null ? void 0 : n.text, s = f({ href: u, field: t });
  return !a && !s ? /* @__PURE__ */ o(k, { ...e, field: t, as: c, role: "link", children: l || m }) : /* @__PURE__ */ o(
    c,
    {
      ...e,
      field: t,
      className: r(
        "neu-button",
        `kind-${(i == null ? void 0 : i.kind) ?? "primary"}`,
        `color-${(i == null ? void 0 : i.color) ?? "main"}`,
        `size-${(i == null ? void 0 : i.size) ?? "default"}`,
        i.className
      )
    }
  );
};
export {
  N as B
};
